import React from 'react'

const Account = () =>
  <div> TODO account page </div>

export default Account
